import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { SetComponentLanguage, ApiRequest, DeepCopy } from '../../../helpers';
import LocalizedStrings from 'react-localization';
import moment from 'moment';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './GeneralSeating.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);
let channel = {};

class GeneralSeating extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isAvailable: true,
            pricingOptions: {
                tickets: []
            }
        }
    }

    getRemainingSeats = async (displayModalIfNoRemaining) => {
        try {
            const response = await getHeldSeats(this.props.ticketSelection.event_date_id);
            console.log('Get Seats:', response);

            const remainingSeats = this.props.max_seats - response.data.count;
            if (displayModalIfNoRemaining && remainingSeats <= 0 && !this.props.isNoTicketsOpen) {
                this.props.toggleNoTickets(true);
            }

            this.setState({ isAvailable: remainingSeats > 0 });
        } catch (error) {
            console.log(error);
        }

        async function getHeldSeats(event_date_id) {
            return await ApiRequest(`/event-dates/${event_date_id}/house-count`, {
                method: 'GET'
            });
        }
    }

    setFlexpassPricingOptions = () => {
        let pricingOptions = DeepCopy(this.props.ticketSelection);
        pricingOptions.tickets.map((ticket) => {
            ticket['value'] = ticket.visibility || ticket.value;
        })
        this.setState({ pricingOptions });
    }

    setEventsPricingOptions = () => {
        let pricingOptions = DeepCopy(this.props.ticketSelection);
        this.props.events.find(event => event.id === pricingOptions.id)
            .event_dates.find(date => date.id === pricingOptions.event_date_id)
                .section_pricing[0].options.map(option => {
                    pricingOptions.tickets.map(ticket => {
                        if (ticket.id === option.id) {
                            ticket['value'] = option.value;
                        }
                    })
                });
        this.setState({ pricingOptions });
    }

    listenForWebsocketMessages = () => {
        // If channel is already assigned, unsubscribe from 'seats-remaining-update'
        channel.name && channel.unsubscribe('seats-remaining-update');

        // Listen to channel to change status of seats & subscribe to 'seats-remaining-update'
        channel = window.Ably.channels.get(`seat-availability:${this.props.ticketSelection.event_date_id}`);
        channel.subscribe('seats-remaining-update', (message) => {
            // Check how many seats available for this event
            this.getRemainingSeats();
            console.log(message.data, channel.name);
        });
    }

    componentDidMount() {
        console.log('componentDidMount');

        if(this.props.ticketSelection.type === 'general-admission'){
            this.getRemainingSeats(true);
            this.listenForWebsocketMessages();
        }
    }

    componentDidUpdate(prevProps) {
        console.log('updated');
        if (prevProps !== this.props) {
            console.log('props dont match, do stuff');
            if (this.props.ticketSelection.type === 'flexpass') {
                console.log('flexpass');
                this.setFlexpassPricingOptions();
            } else {
                console.log('tickets');
                if (prevProps.ticketSelection.event_date_id !== this.props.ticketSelection.event_date_id) {
                    this.listenForWebsocketMessages();
                    this.getRemainingSeats(true);
                }
                this.setEventsPricingOptions();
            }
        }
    }

    componentWillUnmount() {
        if(this.props.ticketSelection.type === 'general-admission'){
            channel.unsubscribe('seats-remaining-update');
        }
    }

    render() {
        let dateString = moment.utc(this.props.ticketSelection.date).format('LLLL');
        if (this.props.ticketSelection.date) {
            dateString = moment(this.props.ticketSelection.date.substring(0, 19)).format('LLLL').toString();
        }
        const isEventType = this.props.ticketSelection.event_type === 'Event' || this.props.ticketSelection.event_type === 'Live Stream' || this.props.ticketSelection.event_type === 'Scheduled Content';
        const numberOfTicketsLabel = (isEventType) ? strings.numberOfTickets : strings.selectQuantity;

        const isStream = this.props.ticketSelection.event_type === 'Video On Demand' || this.props.ticketSelection.event_type === 'Live Stream' || this.props.ticketSelection.event_type === 'Scheduled Content';
        return (
            <div className="showtix-tickets mt-3 mb-3" id="tickets">
                <button
                    className={"showtix-category__button showtix-category__button__tickets" + (this.props.isTicketsOpen ? ' is-active' : '')}
                    onClick={() => this.props.toggleTickets()}
                    aria-expanded={this.props.isTicketsOpen}
                    aria-controls='general-seating'
                    id="ticket-button"
                >{strings.ticketSelection} <i></i>
                </button>
                <div id="general-seating" className={"showtix-tickets__content " + (this.props.isTicketsOpen ? 'is-active' : '')}>
                    <div className="showtix-section showtix-background__primary-2">
                        <div className="container">
                            <div className="row">
                                <div className="col-12 col-md-3 d-none d-md-block">
                                    <div className="showtix-event__poster">
                                        {this.props.ticketSelection.poster_graphic_url ?
                                            <img src={this.props.ticketSelection.poster_graphic_url} alt="" />
                                            :
                                            (this.props.ticketSelection.type === "flexpass" ?
                                                <img src={process.env.REACT_APP_PUBLIC_URL + "/images/generic_poster_flex.jpg"} key={0} alt="" />
                                                :
                                                <img src={process.env.REACT_APP_PUBLIC_URL + "/images/generic_poster_event.jpg"} key={1} alt="" />
                                            )
                                        }
                                    </div>
                                </div>
                                <div className="col-12 col-md-9 pl-md-0">
                                    <div className="showtix-event__tickets">
                                        <h2 className="text-left mb-1">{ReactHtmlParser(this.props.ticketSelection.name)}</h2>
                                        {this.props.ticketSelection.type !== 'flexpass' ?
                                            <React.Fragment>
                                                {isEventType && (
                                                    <p className="date text-left">{dateString}</p>
                                                )}
                                                <p className="text-left">{numberOfTicketsLabel}</p>
                                            </React.Fragment>
                                            :
                                            <p className="text-left">{strings.numberOfFlexpasses}</p> 
                                        }
                                    </div>
                                    {this.state.isAvailable ?
                                        <div className="row">
                                            <div className="col-12">
                                                {this.state.pricingOptions.tickets.map((ticket, i) => {
                                                    if(ticket.value !== 'hidden') {
                                                        if (!this.props.user.role) {
                                                            if (ticket.value === 'all') {
                                                                return <div className="row showtix-event__price" key={i}>
                                                                    <div className="col-12 col-sm-6 text-left showtix-event__admission">
                                                                        <label htmlFor={`price-${i}`}>
                                                                            {ticket.desc} - {new Intl.NumberFormat('en-US', {
                                                                                style: 'currency',
                                                                                currency: 'USD'
                                                                            }).format(ticket.amount)}
                                                                        </label>
                                                                    </div>
                                                                    <div className="col-12 col-sm-6">
                                                                        <div className="showtix-form__select">
                                                                            <select className="showtix-input"
                                                                                amount={ticket.amount}
                                                                                name={ticket.desc}
                                                                                value={ticket.quantity}
                                                                                id={`price-${i}`}
                                                                                onChange={e => this.props.handleTicketSelection(e, i, ticket)}
                                                                            >
                                                                                <option value="0">0 {isStream ? 'device' : 'ticket'}</option>
                                                                                <option value="1">1 {isStream ? 'device' : 'ticket'}</option>
                                                                                <option value="2">2 {isStream ? 'devices' : 'tickets'}</option>
                                                                                <option value="3">3 {isStream ? 'devices' : 'tickets'}</option>
                                                                                <option value="4">4 {isStream ? 'devices' : 'tickets'}</option>
                                                                                <option value="5">5 {isStream ? 'devices' : 'tickets'}</option>
                                                                                <option value="6">6 {isStream ? 'devices' : 'tickets'}</option>
                                                                                <option value="7">7 {isStream ? 'devices' : 'tickets'}</option>
                                                                                <option value="8">8 {isStream ? 'devices' : 'tickets'}</option>
                                                                                <option value="9">9 {isStream ? 'devices' : 'tickets'}</option>
                                                                                <option value="10">10 {isStream ? 'devices' : 'tickets'}</option>
                                                                                <option value="11">11 {isStream ? 'devices' : 'tickets'}</option>
                                                                                <option value="12">12 {isStream ? 'devices' : 'tickets'}</option>
                                                                                <option value="13">13 {isStream ? 'devices' : 'tickets'}</option>
                                                                                <option value="14">14 {isStream ? 'devices' : 'tickets'}</option>
                                                                                <option value="15">15 {isStream ? 'devices' : 'tickets'}</option>
                                                                                <option value="16">16 {isStream ? 'devices' : 'tickets'}</option>
                                                                                <option value="17">17 {isStream ? 'devices' : 'tickets'}</option>
                                                                                <option value="18">18 {isStream ? 'devices' : 'tickets'}</option>
                                                                                <option value="19">19 {isStream ? 'devices' : 'tickets'}</option>
                                                                                <option value="20">20 {isStream ? 'devices' : 'tickets'}</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }
                                                        } else {
                                                            return <div className="row showtix-event__price" key={i}>
                                                                <div className="col-12 col-sm-8 text-left showtix-event__admission">
                                                                    <label htmlFor={`price-${i}`}>
                                                                        {ticket.desc} - {new Intl.NumberFormat('en-US', {
                                                                            style: 'currency',
                                                                            currency: 'USD'
                                                                        }).format(ticket.amount)}
                                                                        { ticket.value === 'box-office' && ' (Box Office Only Price)' }
                                                                    </label>
                                                                </div>
                                                                <div className="col-12 col-sm-4 col-lg-2">
                                                                    <input
                                                                        className="showtix-input text-center"
                                                                        type="number"
                                                                        amount={ticket.amount}
                                                                        name={ticket.desc}
                                                                        min="0"
                                                                        id={`price-${i}`}
                                                                        value={ticket.quantity}
                                                                        onChange={e => this.props.handleTicketSelection(e, i, ticket)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        }
                                                    }
                                                })}
                                            </div>
                                            <div className="col-12 col-lg-5"></div>
                                        </div>
                                    :
                                        <div className="generic-msg">{strings.noTickets}</div>
                                    }
                                    {this.props.ticketSelection.artists.length > 0 &&
                                        <div className="row mt-4">
                                            <div className="col-12 col-lg-7">
                                                <div className="showtix-form__group">
                                                    <label htmlFor="artistId" className="text-left font-weight-light showtix-color__white">{strings.credit}</label>
                                                    <div className="showtix-form__select">
                                                        <select className="showtix-input"
                                                            object="ticketSelection"
                                                            name="artistId"
                                                            id="artistId"
                                                            value={this.props.ticketSelection.artistId}
                                                            onChange={e => this.props.handleCreditsSelection(e)}
                                                        >
                                                            <option value="undefined">{strings.selectArtist}</option>
                                                            {
                                                            this.props.ticketSelection.artists.map((artist, i) => <option key={i} value={artist.id}>{ReactHtmlParser(artist.first_name)} {ReactHtmlParser(artist.last_name)}, {artist.position}</option>)
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 d-flex justify-content-center mt-3">
                                    <button
                                        className="showtix-button showtix-background__primary-3"
                                        onClick={() => {
                                                    for (let key in this.props.isCategoryOpen) {
                                                        this.props.isCategoryOpen[key] === true && this.props.toggleCategory(key)
                                                    }
                                                    this.props.toggleBilling(true);
                                                    this.props.isTicketsOpen && this.props.toggleTickets();
                                                    this.props.updateTicketsInCart(this.props.ticketSelection, this.props.ticketSelection.type);
                                                    this.props.clearTicketSelection();
                                                }}
                                        disabled={this.props.ticketSelection.tickets.every(ticket => !Number(ticket.quantity) > 0) && this.props.cartItems.length === 0 || this.props.isCheckoutDisabled}
                                    >{strings.checkout}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>   
         )
    }
}

GeneralSeating.propTypes = {
    ticketSelection: PropTypes.shape({
        date: PropTypes.string,
        poster_graphic_url: PropTypes.string,
        name: PropTypes.string,
        type: PropTypes.string,
        tickets: PropTypes.array
    }),
    isTicketsOpen: PropTypes.bool,
    toggleBilling: PropTypes.func,
    clearTicketSelection: PropTypes.func,
    updateTicketsInCart: PropTypes.func
}
 
export default GeneralSeating;


// WEBPACK FOOTER //
// ./src/components/EventListing/GeneralSeating/GeneralSeating.js